<template v-if="puedeAccederModulo">
  <div class="pa-2">
    <layout-sub-modulo>
      <template #title> Parámetros generales </template>
      <template #body>
        <div class="d-flex justify-end pa-4">
          <v-btn
            v-if="puedeCrearCompania"
            v-show="validacionBtn"
            @click="abrirModal(null)"
          >
            <v-icon large title="Registrar Compañía" color="#0077b6">
              add_circle
            </v-icon>
          </v-btn>
        </div>

        <div v-if="puedeVerParametros">
          <parametros-generales-table
            :items="listaParametros"
            :mostrar-opciones="puedeActualizar"
            @editar-parametro="abrirModal"
          />

          <crear-editar-compania-modal
            ref="modalCrearEditarCompaniaRef"
            @guardar="procesarGuardado"
            @mostrar-error="mostrarError"
          />
        </div>
      </template>
    </layout-sub-modulo>
  </div>
</template>

<script>
import swal2 from 'sweetalert2';

import { permisosParametrizacionCompaniaMixin } from '../../../mixins/Permisos/Configurar/parametrizacionCompaniaMixin.js';
import apiDocumentosService from '../../../Services/apiDocumentosService.js';
import parametrosGeneralesService from '../../../Services/parametrosGeneralesService.js';
import { alertSuccess } from '../../../utils/alertUtil.js';
import ParametrosGeneralesTable from './Table/ParametrosGeneralesTable.vue';
import CrearEditarCompaniaModal from './Modal/CrearEditarCompania.vue';
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';

export default {
  name: 'ParametrizacionCompania',

  components: {
    ParametrosGeneralesTable,
    CrearEditarCompaniaModal,
    LayoutSubModulo,
  },

  data() {
    return {
      modalCrearEditarCompaniaRef: null,
      listaParametros: [],
      itemSeleccionado: null,
      validacionBtn: false,
    };
  },

  computed: {
    puedeAccederModulo() {
      return this.permisosParametrizacionCompania.accesoModulo;
    },

    puedeCrearCompania() {
      return this.permisosParametrizacionCompania.crearCompania;
    },

    puedeActualizar() {
      return this.permisosParametrizacionCompania.actualizarCompania;
    },

    puedeVerParametros() {
      return this.permisosParametrizacionCompania.verCompania;
    },
  },

  created() {
    this.listarParametrosGenerales();
  },

  mixins: [permisosParametrizacionCompaniaMixin],

  methods: {
    async listarParametrosGenerales() {
      const respuesta = await parametrosGeneralesService.buscarTodos();

      this.validacionBtn = respuesta.length === 0;
      this.listaParametros = respuesta;
    },

    async obtenerColorFooter() {
      try {
        const respuesta =
          await parametrosGeneralesService.obtenerParametrizacionInicial();
        const response = Array.isArray(respuesta) ? respuesta[0] : respuesta;
        const colorFooter = response ? response.color : '#f0ebeb';
        this.$store.commit('setColorFooter', colorFooter);
      } catch {
        this.$store.commit('setColorFooter', '#f0ebeb');
      }
    },

    async crear(datosFormulario) {
      const nombreLogo = datosFormulario.logoBinario
        ? await this.cargarLogo(datosFormulario.logoBinario)
        : '';

      if (datosFormulario.logoBinario && !nombreLogo) {
        return false;
      }

      const resultado = await parametrosGeneralesService.crear({
        url: datosFormulario.url,
        nombrePlataforma: datosFormulario.nombrePlataforma,
        color: datosFormulario.color,
        urlLogo: nombreLogo,
      });

      if (!resultado) return false;

      await alertSuccess('Empresa creada correctamente', 2000);
      return true;
    },

    async actualizar(datosFormulario) {
      const tieneNuevoLogo = datosFormulario.logoBinario !== null;

      const logo = tieneNuevoLogo
        ? await this.actualizarLogo(
            datosFormulario.logoBinario,
            this.itemSeleccionado.urlLogo
          )
        : this.itemSeleccionado.urlLogo;

      const resultado = await parametrosGeneralesService.actualizar(
        this.itemSeleccionado._id,
        {
          url: datosFormulario.url,
          nombrePlataforma: datosFormulario.nombrePlataforma,
          color: datosFormulario.color,
          urlLogo: logo,
        }
      );

      if (!resultado) return false;

      await alertSuccess('Parametrización modificada correctamente', 2000);
      return true;
    },

    async procesarGuardado({ datosFormulario, datosIniciales }) {
      const esEdicion = datosIniciales !== null;

      const operacionExitosa = esEdicion
        ? await this.actualizar(datosFormulario)
        : await this.crear(datosFormulario);

      if (!operacionExitosa) {
        return;
      }

      this.$refs.modalCrearEditarCompaniaRef.cerrarModal();
      this.itemSeleccionado = null;

      await this.listarParametrosGenerales();
      await this.obtenerColorFooter();
    },

    async cargarLogo(logoBinario) {
      const datosFormulario = new FormData();
      datosFormulario.append('file', logoBinario);
      const respuesta = await apiDocumentosService.guardarArchivo(
        'Logo',
        datosFormulario
      );
      return respuesta.img;
    },

    async actualizarLogo(logoBinario, nombreLogoAntiguo) {
      const datosFormulario = new FormData();
      datosFormulario.append('file', logoBinario);
      const respuesta = await apiDocumentosService.actualizarArchivo(
        'Logo',
        nombreLogoAntiguo,
        datosFormulario
      );
      return respuesta.img;
    },

    abrirModal(item) {
      this.itemSeleccionado = item;
      this.$refs.modalCrearEditarCompaniaRef.abrirModal(item);
    },

    mostrarError(mensaje) {
      swal2.fire({
        title: '¡Incorrecto!',
        html: `<span style='font-family:Roboto;'>${mensaje}</span>`,
        icon: 'error',
        timer: 5000,
      });
    },
  },
};
</script>
